<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.ImagesSpaces.show") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required disabled />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required disabled/>
          <!-- End:: Name Input -->
          <!-- Start:: Sport Input -->
          <base-input col="6" type="text" :placeholder="$t('TABLES.ImagesSpaces.startDate')" v-model.trim="data.start" disabled />
          <base-input col="6" type="text" :placeholder="$t('TABLES.ImagesSpaces.endDate')" v-model.trim="data.end" disabled />
          <!-- End:: Sport Input -->
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input col="6" identifier="image" :preSelectedImage="data.image.path"
                                   :placeholder="$t('PLACEHOLDERS.image')" required disabled />
          <!-- End:: Image Upload Input -->
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.active" hide-details disabled></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>

export default {
  name: "showSlider",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        start: null,
        end: null,
        active: true,
        image: {
          path: null,
          file: null,
        },
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
  },

  methods: {
    // start show data
    async showSlider() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sliders/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.Slider.trans.name.ar;
        this.data.nameEn = res.data.data.Slider.trans.name.en;
        this.data.active = res.data.data.Slider.is_active;
        this.data.image.path = res.data.data.Slider.image;
        this.data.start = res.data.data.Slider.start;
        this.data.end = res.data.data.Slider.end;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data


  },

  created() {
    // Start:: Fire Methods
    this.showSlider();
    // End:: Fire Methods
  },
};
</script>
